<template>
    <!-- 与门诊收费系统保持一致，仅负责图标和文案，不处理支付业务。 -->
    <span class="pay_method_card_content">
        <svg v-if="method === 'SQB'" class="pay_method_icon" viewBox="0 0 48 48" fill="none" aria-hidden="true">
            <rect x="17" y="3" width="17" height="22" rx="3" stroke="currentColor" stroke-width="2" />
            <path d="M21 8h9M21 12h9M21 16h6" stroke="currentColor" stroke-width="2" />
            <path d="m12 25 6-6m18 6-6-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            <path d="m8 31 5-9h22l5 9v10H8V31Z" fill="currentColor" fill-opacity=".12" stroke="currentColor" stroke-width="2" />
            <path d="M8 31h32" stroke="currentColor" stroke-width="2" />
            <rect x="17" y="26" width="14" height="3" rx="1.5" fill="currentColor" />
            <circle cx="24" cy="36" r="2" fill="currentColor" />
        </svg>
        <svg v-else-if="method === 'SELF_SCAN'" class="pay_method_icon" viewBox="0 0 48 48" fill="none" aria-hidden="true">
            <path d="M4 15a11 11 0 0 1 22 0c0 6-5 10-11 10l-6 3 1-5c-4-2-6-4-6-8Z" fill="currentColor" fill-opacity=".12" stroke="currentColor" stroke-width="2" />
            <circle cx="11" cy="14" r="1.5" fill="currentColor" />
            <circle cx="19" cy="14" r="1.5" fill="currentColor" />
            <rect x="24" y="18" width="19" height="26" rx="3" fill="var(--el-fill-color-blank)" stroke="currentColor" stroke-width="2" />
            <path d="M28 23h4v4h-4zM35 23h4v4h-4zM28 30h4v4h-4z" stroke="currentColor" stroke-width="1.5" />
            <path d="M35 30h4v5h-4v-2M31 39h5" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
        </svg>
        <svg v-else class="pay_method_icon" viewBox="0 0 48 48" fill="none" aria-hidden="true">
            <path d="m9 15 27-7 5 20" stroke="currentColor" stroke-width="2" stroke-linejoin="round" />
            <rect x="4" y="16" width="36" height="23" rx="3" fill="currentColor" fill-opacity=".12" stroke="currentColor" stroke-width="2" />
            <path d="M9 22h3M32 33h3M20 22l3 5 3-5M19 28h8M19 32h8M23 27v8" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
        <span class="pay_method_name">{{ methodName }}</span>
        <span class="pay_method_description">{{ methodDescription }}</span>
    </span>
</template>

<script>
export default {
    name: 'CashierPaymentMethod',
    props: {
        method: {
            type: String,
            required: true,
            validator: value => ['SQB', 'SELF_SCAN', 'CASH'].includes(value)
        }
    },
    computed: {
        methodName() {
            return {SQB: '线上支付', SELF_SCAN: '客户自主扫码', CASH: '现金缴费'}[this.method];
        },
        methodDescription() {
            return {
                SQB: '收钱吧盒子扫付款码',
                SELF_SCAN: '患者微信扫描收款码',
                CASH: '患者现场现金付款'
            }[this.method];
        }
    }
};
</script>

<style scoped>
.pay_method_card_content {
    display: grid;
    grid-template-columns: 36px minmax(0, max-content);
    gap: 6px 10px;
    align-items: center;
    width: fit-content;
    max-width: 100%;
    margin: 0 auto;
    min-width: 0;
    text-align: left;
}

.pay_method_icon {
    grid-row: 1 / 3;
    width: 36px;
    height: 36px;
    color: var(--el-color-primary);
}

.pay_method_name {
    color: var(--el-text-color-primary);
    font-size: 16px;
    font-weight: 600;
    line-height: 22px;
}

.pay_method_description {
    color: var(--el-text-color-secondary);
    font-size: 13px;
    line-height: 19px;
    overflow-wrap: anywhere;
}
</style>
